module.exports = __webpack_public_path__ + "static/media/checked.8ec3bf52.svg";